import {IconButton} from '@wandb/components';
import React from 'react';

export const BackButton = ({onClick}: {onClick: () => void}) => {
  return (
    <IconButton
      icon="back"
      variant="ghost"
      onClick={onClick}
      aria-label="Workspace drawer back"
    />
  );
};
